import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);
import router from "./router";
import store from "./store";
import "@/styles";
import useImports from "@/imports";
import "@/services/socket";
useImports(app);
app.use(store);
app.use(router);
app.mount("#app");
